export const UserRoles = {
  ClientAdmin: "Client-Admin",
  MakePayment: "Client-MakePayment",
  RefundPayment: "Client-RefundPayment",
  ApprovePayment: "Client-ApprovePayment",
  ManageProducts: "Client-ManageProduct",
};
